import React, { FC } from "react"
import { HStack, IconButton } from "@chakra-ui/react"
import { useRef } from "react"
import { IoChevronBack, IoChevronForward } from "react-icons/io5"
import { AuthPageStyling } from "src/context/types"
import usePageStyling from "src/hooks/usePageStyling"
import { AvatarConfig } from "src/recoil/atoms/avatars/types"
import { useIsMobileDevice } from "src/util/browser"
import { Inspiration } from "./Inspiration"

export type InspirationModel = {
  title: string
  description: string
  prompt: string
  thumbnailURL: string
  languageCode: string
  position: number
  avatar?: AvatarConfig
  defaultAvatarId?: string
  categoryIds?: number[]
  chatContent?: string
  tag?: string
}

export const Inspirations = ({
  inspirations,
  onClick
}: {
  inspirations: InspirationModel[]
  onClick?: (inspiration: InspirationModel) => void
}) => {
  // const itemWidth = useBreakpointValue({ base: "150px", md: "200px" });
  // const refs = inspirations?.map(() => React.useRef())

  return (
    <ScrollableSnapContainer>
      {inspirations?.map((inspiration, index) => (
        <Inspiration
          onClick={onClick}
          showAvatar={true}
          key={index}
          inspiration={inspiration}
          miniCard={true}
        />
      ))}
    </ScrollableSnapContainer>
  )
}

const ScrollableSnapContainer: FC = ({ children }) => {
  return (
    <HStack spacing={2} align="center" width={"full"}>
      <HStack
        display="flex"
        overflowX="auto"
        overscrollBehaviorX={"contain"}
        className="hide-scrollbar"
        width={"full"}
        align="normal"
      >
        {children}
      </HStack>
    </HStack>
  )
}
